"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetRequestToJSON = exports.BudgetRequestFromJSONTyped = exports.BudgetRequestFromJSON = exports.instanceOfBudgetRequest = exports.BudgetRequestTypeEnum = void 0;
/**
 * @export
 */
exports.BudgetRequestTypeEnum = {
    Daily: 'DAILY',
    Lifetime: 'LIFETIME'
};
/**
 * Check if a given object implements the BudgetRequest interface.
 */
function instanceOfBudgetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "microAmount" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfBudgetRequest = instanceOfBudgetRequest;
function BudgetRequestFromJSON(json) {
    return BudgetRequestFromJSONTyped(json, false);
}
exports.BudgetRequestFromJSON = BudgetRequestFromJSON;
function BudgetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'microAmount': json['micro_amount'],
        'type': json['type'],
    };
}
exports.BudgetRequestFromJSONTyped = BudgetRequestFromJSONTyped;
function BudgetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'micro_amount': value.microAmount,
        'type': value.type,
    };
}
exports.BudgetRequestToJSON = BudgetRequestToJSON;
